/**
 * 应用配置
 */

// 环境变量
const env = import.meta.env

// 基础配置
export const config = {
  // 应用信息
  app: {
    name: env.VITE_APP_TITLE || '管理系统',
    version: env.VITE_APP_VERSION || '1.0.0',
    description: '基于Vue3的管理系统'
  },
  
  // API配置
  api: {
    baseURL: env.VITE_API_BASE_URL || '/web',
    timeout: 10000,
    withCredentials: false
  },
  
  // 分页配置
  pagination: {
    defaultPageSize: 10,
    pageSizes: [10, 20, 50, 100],
    layout: 'total, sizes, prev, pager, next, jumper'
  },
  
  // 表格配置
  table: {
    stripe: true,
    border: false,
    size: 'default',
    emptyText: '暂无数据'
  },
  
  // 表单配置
  form: {
    labelWidth: '100px',
    labelPosition: 'right',
    size: 'default'
  },
  
  // 上传配置
  upload: {
    maxSize: 5 * 1024 * 1024, // 5MB
    acceptTypes: ['image/jpeg', 'image/png', 'image/gif'],
    // 图片上传接口
    imageAction: env.VITE_API_BASE_URL ? `${env.VITE_API_BASE_URL}/upload/images` : '/web/upload/images',
    // 视频上传接口
    videoAction: env.VITE_API_BASE_URL ? `${env.VITE_API_BASE_URL}/upload/file` : '/web/upload/file',
    // 通用文件上传接口（保持兼容性）
    action: env.VITE_UPLOAD_URL || '/web/upload-file'
  },
  
  // 缓存配置
  cache: {
    tokenKey: 'token',
    userInfoKey: 'userInfo',
    settingsKey: 'settings'
  }
}

// 开发环境配置
export const devConfig = {
  debug: true,
  mock: false,
  showDevtools: true
}

// 生产环境配置
export const prodConfig = {
  debug: false,
  mock: false,
  showDevtools: false
}

// 根据环境获取配置
export const getConfig = () => {
  const baseConfig = config
  
  if (env.DEV) {
    return { ...baseConfig, ...devConfig }
  }
  
  return { ...baseConfig, ...prodConfig }
}

export default getConfig()